import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Sparkles } from 'lucide-react';
import { STORE_CONFIG } from '../../config/storeConfig';

const ANNOUNCEMENTS = [
  'Increase your Height with MAXBIQ Powder',
  'Free Shipping Above Rupees 2000',
  'Cash on Delivery Available Nationwide in Pakistan',
];

export const AnnouncementBar: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % ANNOUNCEMENTS.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handlePrev = () => {
    setCurrentIndex(prev => (prev - 1 + ANNOUNCEMENTS.length) % ANNOUNCEMENTS.length);
  };

  const handleNext = () => {
    setCurrentIndex(prev => (prev + 1) % ANNOUNCEMENTS.length);
  };

  return (
    <div
      id="announcement-bar"
      className="w-full bg-[#0E1546] text-white h-[38px] sm:h-[42px] flex items-center justify-between px-4 sm:px-8 text-xs sm:text-[13px] font-bold tracking-wide shadow-sm relative z-40 border-b border-[#1E293B]"
    >
      <button
        id="announcement-prev-btn"
        onClick={handlePrev}
        aria-label="Previous announcement"
        className="p-1 hover:opacity-75 transition-opacity text-white/80 hover:text-white"
      >
        <ChevronLeft className="w-4 h-4" />
      </button>

      <div className="flex items-center justify-center gap-2 overflow-hidden text-center px-2">
        <span className="font-bold tracking-wide text-white transition-all duration-300 line-clamp-1">
          {ANNOUNCEMENTS[currentIndex]}
        </span>
      </div>

      <button
        id="announcement-next-btn"
        onClick={handleNext}
        aria-label="Next announcement"
        className="p-1 hover:opacity-75 transition-opacity text-white/80 hover:text-white"
      >
        <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
};
